export const LEGAL_LINKS = {
    PRIVACY_POLICY: "https://xpass.com.tr/privacy",
    KVKK_AYDINLATMA: "https://xpass.com.tr/kvkk",
    SUPPORT: "https://xpass.com.tr/support"
};
